export default [
    {
        id: 1,
        title: 'Rap',
        cover: 'https://t.scdn.co/images/8cfa9cb1e43a404db76eed6ad594057c',
        color: '#1E3264'
    },
    {
        id: 2,
        title: 'Hip-Hop',
        cover: 'https://i.scdn.co/image/ab67706f000000029bb6af539d072de34548d15c', 
        color: '#BA5D07'
    },
    {
        id: 3,
        title: 'Dance / Electronic',
        cover: 'https://i.scdn.co/image/ab67706f000000020377baccf69ede3cf1a26eff',
        color: '#DC148C'
    },
    {
        id: 4,
        title: 'Pop',
        cover: 'https://t.scdn.co/images/0a74d96e091a495bb09c0d83210910c3',
        color: '#8D67AB'
    },
    {
        id: 5,
        title: 'Rock',
        cover: 'https://i.scdn.co/image/ab67706f00000002fe6d8d1019d5b302213e3730',
        color: '#E61E32'
    }
]